import { Chip, IconButton, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import SchoolIcon from '@mui/icons-material/School';
import ProfileImage from '../../ProfileImage';
import Rate from '../../Rate';
import { TeacherInfo } from '../../../types/TeacherInfo';
import './TeacherHeader.css';

interface TeacherHeaderProps {
  teacher: TeacherInfo;
  onBack?: () => void;
}

const TeacherHeader: React.FC<TeacherHeaderProps> = ({ teacher, onBack }) => {
  return (
    <div className="teacherHeader">
      {onBack && (
        <IconButton
          onClick={onBack}
          sx={{
            position: 'absolute',
            left: '1rem',
            top: '1rem',
            color: 'white'
          }}>
          <ArrowBack />
        </IconButton>
      )}
      <ProfileImage image_url={teacher.image_url} size="xl" />
      <Typography
        variant="h5"
        component="div"
        textAlign="center"
        sx={{
          fontSize: {
            sm: '2rem',
            xs: '1.5rem'
          }
        }}
        className="teacherHeaderName">
        {teacher.first_name} {teacher.last_name}
        {teacher.rate && teacher.rate.average > 0 && (
          <Rate rate={teacher.rate} textColor="white" emptyStarBorderColor="#faaf00" />
        )}
      </Typography>
      <div className="teacherHeaderPricePerHourContainer">
        <h4>${teacher.price_per_hour}</h4>
        <h4> / hora</h4>
      </div>
      <div>
        {teacher.dictated_classes && teacher.dictated_classes! > 0 && (
          <Chip
            icon={<SchoolIcon />}
            label={`${teacher.dictated_classes} clases dictadas`}
            size="small"
            variant="outlined"
            sx={{
              color: 'white',
              borderColor: 'white',
              '& .MuiChip-icon': {
                color: 'white'
              }
            }}
          />
        )}
      </div>
    </div>
  );
};

export default TeacherHeader;
